import { Box, Typography } from '@mui/material';

export const WALLET_TABS = [
  { id: 'xps', label: 'XPs' },
  { id: 'rapcoins', label: 'RapCoins' },
  { id: 'rapgems', label: 'RapGems' },
  { id: 'viproom', label: 'VIP Rooms' },
];

const TRACK_PADDING = 5;

const tabLabelSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: { xs: 13, sm: 16 },
  lineHeight: '24px',
  letterSpacing: '0.8px',
  color: '#fff',
  textAlign: 'center',
  whiteSpace: 'nowrap',
};

/** Figma 9679:1333 — wallet currency tab switcher */
export default function WalletTabSwitcher({ value, onChange }) {
  const activeIndex = Math.max(
    WALLET_TABS.findIndex((tab) => tab.id === value),
    0
  );

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 745,
        mx: 'auto',
        p: `${TRACK_PADDING}px`,
        borderRadius: '60px',
        bgcolor: '#3d0066',
        boxShadow: 'inset 0 4px 4px rgba(0, 0, 0, 0.25)',
      }}
    >
      {/* Figma 9679:1334 — sliding active pill */}
      <Box
        sx={{
          position: 'absolute',
          top: 3,
          bottom: 3,
          left: `calc(${TRACK_PADDING - 2}px + ${activeIndex} * (100% - ${TRACK_PADDING * 2 - 4}px) / ${WALLET_TABS.length})`,
          width: `calc((100% - ${TRACK_PADDING * 2 - 4}px) / ${WALLET_TABS.length})`,
          borderRadius: '100px',
          border: '1px solid #ffc5f7',
          background: 'linear-gradient(270deg, #ff00f2 0%, #822aff 100%)',
          boxShadow:
            'inset 2px 2px 5px rgba(255, 255, 255, 0.35), inset -2px -2px 6px rgba(0, 0, 0, 0.25)',
          transition: 'left 0.25s ease',
          pointerEvents: 'none',
        }}
      />

      {WALLET_TABS.map((tab) => (
        <Box
          key={tab.id}
          component="button"
          type="button"
          onClick={() => onChange(tab.id)}
          aria-pressed={tab.id === value}
          sx={{
            position: 'relative',
            zIndex: 1,
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 1, sm: 2 },
            py: '8px',
            border: 0,
            borderRadius: '40px',
            bgcolor: 'transparent',
            cursor: 'pointer',
          }}
        >
          <Typography component="span" sx={tabLabelSx}>
            {tab.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
